import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from '@ff-os/shared-react/components/dropdown/Dropdown';
import { ListItem } from '@ff-os/shared-react/components/list/ListItem';
import { VariantOption } from '../../../../VariantOption';
import styles from './VariantDropdown.module.scss';

export const VariantDropdown = ({
    label, value, onChange, options, className
}: Props) => {

    const selected = options.find(o => o.value === value)!;
    return (
    <>
        <Dropdown
            label={label}
            renderPreview={() => <OptionText {...selected} />}
            className={className}
            fieldClassName={styles.field}>
            {options.map(o => (
                <ListItem key={o.value}
                    onClick={() => onChange(o.value)}
                    active={o.value === value}>
                    <OptionText {...o} />
                </ListItem>
            ))}
        </Dropdown>
    </>
    );
};

const OptionText = ({ label } : VariantOption) => {
    const { t } = useTranslation();
    return (
        <span className={styles.optionText}>
            {label && <>{t(label.key, label.args)}</>}
        </span>
    );
};

type Props = {
    label: string;
    value: string;
    className?: string;
    onChange: (value: string) => void;
    options: VariantOption[];
};